

































import { Component, Vue } from 'vue-property-decorator'
import { WPS, WPS_DOCS, WPS_OFFICE, OPEN_DOCS, OPEN_AGREEMENT, OPEN_PLUS_WPS, FEEDBACK } from '@/apps/open/constants'
import { priSubPath } from '@/apps/open/constants/index'

export default class FooterInfo extends Vue {
  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  openUrl (name: string) {
    switch (name) {
      case 'wps office':
        window.open(WPS_OFFICE)
        break

      case '金山文档':
        this.isPrivate ? window.open(`${location.origin}${priSubPath}/kdocs`) : window.open(WPS_DOCS)
        break

      case 'wps官网':
        window.open(WPS)
        break

      case '开发文档':
        window.open(OPEN_DOCS)
        break

      case '服务商协议':
        window.open(OPEN_AGREEMENT)
        break

      case 'wps+':
        window.open(OPEN_PLUS_WPS)
        break

      case '问题反馈':
        window.open(FEEDBACK)
    }
  }
}
